export default __webpack_public_path__ + "static/conexum-white-d8c95cd90a7e78bee08c8e59670e9fa1.svg";